import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { delay } from 'rxjs/operators';

@Injectable()

export class TaskPanelService {

  public editorType: 'create' | 'update' = 'update';

  public nextTaskId: BehaviorSubject<number | boolean> = new BehaviorSubject<number>(null);
  private _openSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  open$: Observable<boolean> = this._openSubject.asObservable().pipe(delay(0));

  public isOpen: boolean = false;

  constructor() {
  }

  open(task_id?: number | string): void {
    console.log('open');
    this.editorType = task_id ? 'update' : 'create';
    this.nextTaskId.next(task_id ? parseInt(<string>task_id, 10) : null);
    this._openSubject.next(true);
    this.isOpen = true;
  }

  close(): void {
    console.log('close');
    this._openSubject.next(false);
    this.isOpen = false;
  }
}
